import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { InterventionEventImpl } from "../model/impl/InterventionEventImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class InterventionEventImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: InterventionEventImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.eventId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(1),
        false,
        encodable.eventId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.eventType != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(2),
        false,
        encodable.eventType,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.baseCode != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(3),
        false,
        encodable.baseCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBaseCode != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(4),
        false,
        encodable.nonBaseCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.currencyPair != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(5),
        false,
        encodable.currencyPair,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.timestamp != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(6),
        false,
        encodable.timestamp,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.lockUserId != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(7),
        false,
        encodable.lockUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.reason != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(8),
        false,
        encodable.reason,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.salesGroupId != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(9),
        false,
        encodable.salesGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.traderGroupId != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(10),
        false,
        encodable.traderGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.capabilities != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        true,
        InterventionEventImplEncoder.fidTypeMap.get(11),
        false,
        encodable.capabilities,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.orderData != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(12),
        true,
        encodable.orderData,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingRateRequirement != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(13),
        true,
        encodable.fixingRateRequirement,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.errors != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(14),
        true,
        encodable.errors,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.channelCd != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(15),
        false,
        encodable.channelCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.deal != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(16),
        true,
        encodable.deal,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.operationType != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(17),
        false,
        encodable.operationType,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.unLockUserId != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(18),
        false,
        encodable.unLockUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.transferStatus != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(19),
        false,
        encodable.transferStatus,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.targetTraderGroupId != null) {
      this.baseEncoder.writeStartFid(20, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(20),
        false,
        encodable.targetTraderGroupId,
        streamout,
      );
      this.baseEncoder.writeEndFid(20, streamout);
    }
    /*Object encoding*/
    if (encodable.displayChannelName != null) {
      this.baseEncoder.writeStartFid(21, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(21),
        false,
        encodable.displayChannelName,
        streamout,
      );
      this.baseEncoder.writeEndFid(21, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdRollOrderData != null) {
      this.baseEncoder.writeStartFid(22, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(22),
        true,
        encodable.fwdRollOrderData,
        streamout,
      );
      this.baseEncoder.writeEndFid(22, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        InterventionEventImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,InterventionEventImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "com.bcdfx.model.InterventionEventType"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "java.util.Date"],
    [7, "java.lang.Long"],
    [8, "com.bcdfx.model.DIReason"],
    [9, "java.lang.Long"],
    [10, "java.lang.Long"],
    [11, "com.bcdfx.model.InterventionEventCapability"],
    [12, "com.bcdfx.model.event.lifecycle.fx.OrderData"],
    [13, "com.bcdfx.model.FixingRateRequirementData"],
    [14, "com.bcdfx.model.Errors"],
    [15, "java.lang.String"],
    [16, "com.bcdfx.model.Deal"],
    [17, "com.bcdfx.model.InterventionOperationType"],
    [18, "java.lang.Long"],
    [19, "com.bcdfx.model.TransferStatus"],
    [20, "java.lang.Long"],
    [21, "java.lang.String"],
    [22, "com.bcdfx.model.fwdroll.FwdRollOrderData"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: InterventionEventImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.eventId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.InterventionEventType = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.eventType = <CubiqTS.InterventionEventType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.baseCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.nonBaseCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.currencyPair = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.timestamp = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.lockUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.DIReason = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.reason = <CubiqTS.DIReason>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.salesGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.traderGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: Array<CubiqTS.InterventionEventCapability> = this.baseEncoder.readObject(
            false,
            true,
            InterventionEventImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.capabilities = <Array<CubiqTS.InterventionEventCapability>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.OrderData = this.baseEncoder.readObject(
            true,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.orderData = <CubiqTS.OrderData>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.FixingRateRequirementData = this.baseEncoder.readObject(
            true,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.fixingRateRequirement = <CubiqTS.FixingRateRequirementData>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: CubiqTS.Errors = this.baseEncoder.readObject(
            true,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.errors = <CubiqTS.Errors>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.channelCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: CubiqTS.Deal = this.baseEncoder.readObject(
            true,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.deal = <CubiqTS.Deal>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: CubiqTS.InterventionOperationType = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.operationType = <CubiqTS.InterventionOperationType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.unLockUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: CubiqTS.TransferStatus = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.transferStatus = <CubiqTS.TransferStatus>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 20: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(20),
            streamin,
          );
          encodable.targetTraderGroupId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 21: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(21),
            streamin,
          );
          encodable.displayChannelName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 22: {
          /*Object encoding*/
          let val: CubiqTS.FwdRollOrderData = this.baseEncoder.readObject(
            true,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(22),
            streamin,
          );
          encodable.fwdRollOrderData = <CubiqTS.FwdRollOrderData>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            InterventionEventImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,InterventionEventImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return InterventionEventImplEncoder.fidTypeMap.has(fid);
  }
}
